/* frontend/src/components/CommentList.js */
import React from 'react';
import { motion } from 'framer-motion';
import '../pages/Blog.css';

const CommentList = ({ comments }) => {
  return (
    <div>
      <h3 className="text-xl mb-2">Comments</h3>
      {comments.length === 0 ? (
        <p className="text-[#666666]">No comments yet.</p>
      ) : (
        comments.map((comment) => (
          <motion.div
            key={comment.id}
            className="comment"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <p className="font-bold">{comment.user.username}</p>
            <p>{comment.content}</p>
            <p className="text-[#666666] text-sm">
              {new Date(comment.created_at).toLocaleDateString()}
            </p>
          </motion.div>
        ))
      )}
    </div>
  );
};

export default CommentList;
